// extracted by mini-css-extract-plugin
module.exports = {"afterSalesDesc":"_19745","title":"_1987","arrow":"_16244"};